import React, { PureComponent } from "react";
import {
  Row,
  Button,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Collapse,
  ButtonDropdown,
  ButtonGroup,
} from "reactstrap";
import { injectIntl } from "react-intl";

import { Colxx } from "../../../components/common/CustomBootstrap";
import Breadcrumb from "../../navs/Breadcrumb";
import IntlMessages from "../../../helpers/IntlMessages";
import classnames from "classnames";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import ThumbListIcon from "../../../components/ThumbListIcon";
import DataListIcon from "../../../components/DataListIcon";
import moment from "moment";

const formatDatasExport = (data, intl) => {
  let custs = [];

  for (let i = 0, j = data?.length; i < j; i++) {
    custs.push({
      [intl.formatMessage({ id: "customer.export.stt" })]: i + 1,
      [intl.formatMessage({ id: "customer.export.name" })]: data[i].name,
      [intl.formatMessage({ id: "customer.export.phone" })]: data[i].phone,
      [intl.formatMessage({ id: "customer.export.email" })]: data[i].email,
      [intl.formatMessage({ id: "customer.export.address" })]: data[i].address,
      [intl.formatMessage({ id: "customer.export.used" })]: data[i].used,
      [intl.formatMessage({ id: "customer.export.point" })]: data[i].point,
      [intl.formatMessage({ id: "customer.export.total_spent" })]:
        data[i].total_spent || 0,
      [intl.formatMessage({ id: "customer.export.armorial" })]:
        data[i].armorial,
      [intl.formatMessage({ id: "customer.export.debt" })]: data[i].debt || 0,
      [intl.formatMessage({ id: "customer.export.tags" })]: data[i]?.tags
        ?.map((tag) => tag.label)
        .join(", "),
      [intl.formatMessage({ id: "customer.export.created_at" })]: data[i]
        .createdAt
        ? moment(data[i].createdAt).format("DD/MM/YYYY")
        : "",
      [intl.formatMessage({ id: "customer.export.updated_at" })]: data[i]
        .updatedAt
        ? moment(data[i].updatedAt).format("DD/MM/YYYY")
        : "",
    });
  }
  return custs;
};

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

const exportToCSV = ({ csvData, fileName }) => {
  const ws = XLSX.utils.json_to_sheet(csvData);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
};

class PageHeading extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dropdownSplitOpen: false,
    };
  }

  handleUploadData = () => {
    console.log("Clicked UploadData");
  };

  handleDownloadData = () => {
    const { intl } = this.props;
    const fileName = intl.formatMessage({ id: "customer.export.filename" });

    exportToCSV({
      csvData: formatDatasExport(this.props.data, intl),
      fileName,
    });
  };

  toggleSplit = () => {
    this.setState((prevState) => ({
      dropdownSplitOpen: !prevState.dropdownSplitOpen,
    }));
  };

  toggleDisplayOptions = () => {
    this.setState((prevState) => ({
      displayOptionsIsOpen: !prevState.displayOptionsIsOpen,
    }));
  };

  render() {
    const { messages } = this.props.intl;
    const {
      heading,
      setting,
      match,
      totalItem,
      toggleFunc,
      changePageSizeFunc,
      onSearchKeyFunc,
      displayMode,
      changeDisplayMode,
    } = this.props;

    const startIndex = (setting.currentPage - 1) * setting.selectedPageSize;
    const endIndex = setting.currentPage * setting.selectedPageSize;

    const { displayOptionsIsOpen } = this.state;
    return (
      <Row className="list-page-heading__row">
        <Colxx xxs="12">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="d-flex align-items-center">
              <h1 className="mb-0 mr-2">
                <IntlMessages id={heading} />
              </h1>
              <Breadcrumb match={match} />
            </div>
            <div className="text-zero top-right-button-container d-flex align-items-center">
              <Button
                color="outline-primary"
                className="mr-2 excel-export-pages top-right-button"
                onClick={this.handleDownloadData}
                title={this.props.intl.formatMessage({
                  id: "page.heading.excel.tooltip",
                })}
              >
                <i className="simple-icon-cloud-download mr-1" />
                <IntlMessages id="page.heading.excel" />
              </Button>

              <ButtonGroup>
                <Button
                  color="primary"
                  className="top-right-button"
                  onClick={() => toggleFunc()}
                >
                  <IntlMessages id="pages.add-new" />
                </Button>

                {this.props.selectedItemsLength > 0 && (
                  <Button
                    color="danger"
                    className="top-right-button"
                    onClick={this.props.onHandlerDelete}
                  >
                    <i className="simple-icon-trash mr-1" />
                    <IntlMessages id="pages.delete" /> (
                    {this.props.selectedItemsLength})
                  </Button>
                )}
              </ButtonGroup>
            </div>
          </div>

          <div className="mb-2">
            <Button
              color="empty"
              className="pt-0 pl-0 d-inline-block d-md-none"
              onClick={this.toggleDisplayOptions}
            >
              <IntlMessages id="pages.display-options" />{" "}
              <i className="simple-icon-arrow-down align-middle" />
            </Button>
            <Collapse
              isOpen={displayOptionsIsOpen}
              className="d-md-block"
              id="displayOptions"
            >
              <span className=" d-none d-md-flex mr-3 d-inline-block float-md-left ">
                <a
                  href="#/"
                  className={`mr-2 view-icon ${
                    displayMode === "thumblist" ? "active" : ""
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    changeDisplayMode("thumblist");
                  }}
                >
                  <ThumbListIcon />
                </a>
                <a
                  href="#/"
                  className={`mr-2 view-icon ${
                    displayMode === "list" ? "active" : ""
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    changeDisplayMode("list");
                  }}
                >
                  <DataListIcon />
                </a>
              </span>
              {/* Ẩn search input nếu sử dụng Navbar search (hideSearch=true) */}
              {!this.props.hideSearch && (
                <div className="d-block d-md-inline-block">
                  <div className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top">
                    <input
                      type="text"
                      name="keyword"
                      id="search"
                      placeholder={messages["customer.search"]}
                      onKeyPress={(e) => onSearchKeyFunc(e)}
                      onChange={(e) => onSearchKeyFunc(e)}
                    />
                  </div>
                </div>
              )}
              {displayMode === "list" ? null : (
                <div className="float-md-right">
                  <span className="text-muted text-small mr-1">{`${startIndex}-${endIndex} of ${totalItem} `}</span>
                  <UncontrolledDropdown className="d-inline-block">
                    <DropdownToggle caret color="outline-dark" size="xs">
                      {setting.selectedPageSize}
                    </DropdownToggle>
                    <DropdownMenu right>
                      {setting.pageSizes.map((size, index) => {
                        return (
                          <DropdownItem
                            key={index}
                            onClick={() => changePageSizeFunc(size)}
                          >
                            {size}
                          </DropdownItem>
                        );
                      })}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              )}
            </Collapse>
          </div>
          {/* <Separator /> */}
        </Colxx>
      </Row>
    );
  }
}

export default injectIntl(PageHeading);
